import moment from 'moment';
import APIUtils from '@spothero/utils/api';

const EventsAPI = {
    get({venueId, eventTypes = null, starts = moment().format()}) {
        const data = {
            destination_id: venueId,
            page_size: 0,
            starts,
            include: 'destination,spothero_city'
        };

        if (eventTypes) {
            data.event_types = eventTypes;
        }

        return APIUtils.get('events/', data);
    },

    getById(eventId) {
        return APIUtils.get(`events/${eventId}/`, {
            include: 'destination,spothero_city'
        });
    }
};

export default EventsAPI;



// WEBPACK FOOTER //
// ./widget/src/js/api/events.js